document.addEventListener("turbolinks:load", function () {
  document
    .querySelectorAll(".hasDatepicker")
    .forEach((el) => el.classList.remove("hasDatepicker"));
  $(".fc-datepicker").datepicker({
    showOtherMonths: true,
    selectOtherMonths: true,
  });
});
